import React from "react";
import BasketComponent from "../components/Basket";
const Basket = () => {
  return <BasketComponent />;
};

export default Basket;
